// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-range-slider {
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_16_13-range-slider[ant-5_17_0-click-animating-without-extra-node=true]::after,
.perxis-auto-1_16_13-range-slider > *[ant-5_17_0-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_16_13-range-slider .ant-5_17_0-wave {
  transition: none !important;
}
.perxis-auto-1_16_13-range-slider-wrapper {
  /* Typography */
  --perxis-auto-range-slider-font-family-inner: var(--perxis-auto-range-slider-font-family, var(--perxis-auto-root-typography-small-font-family-inner));
  --perxis-auto-range-slider-font-size-inner: var(--perxis-auto-range-slider-font-size, var(--perxis-auto-root-typography-small-font-size-xxl-inner));
  --perxis-auto-range-slider-font-weight-inner: var(--perxis-auto-range-slider-font-weight, 700);
  --perxis-auto-range-slider-letter-spacing-inner: var(--perxis-auto-range-slider-letter-spacing, var(--perxis-auto-root-typography-small-letter-spacing-inner));
  --perxis-auto-range-slider-line-height-inner: var(--perxis-auto-range-slider-line-height, var(--perxis-auto-root-typography-small-line-height-xxl-inner));
  --perxis-auto-range-slider-text-transform-inner: var(--perxis-auto-range-slider-text-transform, var(--perxis-auto-root-typography-small-text-transform-inner));
  --perxis-auto-range-slider-color-inner: var(--perxis-auto-range-slider-color, var(--perxis-auto-root-typography-color-darkest-inner));
  --perxis-auto-range-slider-mark-font-family-inner: var(--perxis-auto-range-slider-mark-font-family, var(--perxis-auto-root-typography-super-small-font-family-inner));
  --perxis-auto-range-slider-mark-font-size-inner: var(--perxis-auto-range-slider-mark-font-size, var(--perxis-auto-root-typography-super-small-font-size-xxl-inner));
  --perxis-auto-range-slider-mark-font-weight-inner: var(--perxis-auto-range-slider-mark-font-weight, 700);
  --perxis-auto-range-slider-mark-letter-spacing-inner: var(--perxis-auto-range-slider-mark-letter-spacing, var(--perxis-auto-root-typography-super-small-letter-spacing-inner));
  --perxis-auto-range-slider-mark-line-height-inner: var(--perxis-auto-range-slider-mark-line-height, var(--perxis-auto-root-typography-super-small-line-height-xxl-inner));
  --perxis-auto-range-slider-mark-text-transform-inner: var(--perxis-auto-range-slider-mark-text-transform, var(--perxis-auto-root-typography-super-small-text-transform-inner));
  --perxis-auto-range-slider-mark-color-inner: var(--perxis-auto-range-slider-mark-color, var(--perxis-auto-root-typography-color-light-inner));
  /* End Typography */
  /* Colors */
  --perxis-auto-range-slider-first-color-inner: var(--perxis-auto-range-slider-first-color, var(--perxis-auto-root-first-color-inner));
  --perxis-auto-range-slider-second-color-inner: var(--perxis-auto-range-slider-second-color, var(--perxis-auto-root-second-color-inner));
  --perxis-auto-range-slider-third-color-inner: var(--perxis-auto-range-slider-third-color, var(--perxis-auto-root-sixth-color-inner));
  --perxis-auto-range-slider-rail-background-color-inner: var(--perxis-auto-range-slider-rail-background-color, var(--perxis-auto-range-slider-third-color-inner));
  --perxis-auto-range-slider-rail-disabled-background-color-inner: var(--perxis-auto-range-slider-rail-disabled-background-color, var(--perxis-auto-range-slider-third-color-inner));
  --perxis-auto-range-slider-track-background-color-inner: var(--perxis-auto-range-slider-track-background-color, var(--perxis-auto-range-slider-second-color-inner));
  --perxis-auto-range-slider-track-disabled-background-color-inner: var(--perxis-auto-range-slider-track-disabled-background-color, var(--perxis-auto-range-slider-second-color-inner));
  --perxis-auto-range-slider-dot-border-color-inner: var(--perxis-auto-range-slider-dot-border-color, var(--perxis-auto-range-slider-second-color-inner));
  --perxis-auto-range-slider-dot-active-border-color-inner: var(--perxis-auto-range-slider-dot-active-border-color, var(--perxis-auto-range-slider-second-color-inner));
  --perxis-auto-range-slider-handle-background-color-inner: var(--perxis-auto-range-slider-handle-background-color, var(--perxis-auto-range-slider-first-color-inner));
  --perxis-auto-range-slider-handle-disabled-background-color-inner: var(--perxis-auto-range-slider-handle-disabled-background-color, var(--perxis-auto-range-slider-first-color-inner));
  --perxis-auto-range-slider-handle-border-color-inner: var(--perxis-auto-range-slider-handle-border-color, var(--perxis-auto-range-slider-second-color-inner));
  --perxis-auto-range-slider-handle-disabled-border-color-inner: var(--perxis-auto-range-slider-handle-disabled-border-color, var(--perxis-auto-range-slider-second-color-inner));
  /* End Colors */
  /* Handle */
  --perxis-auto-range-slider-handle-border-radius-inner: var(--perxis-auto-range-slider-handle-border-radius, 50%);
  --perxis-auto-range-slider-handle-border-width-inner: var(--perxis-auto-range-slider-handle-border-width, 4px);
  --perxis-auto-range-slider-handle-width-inner: var(--perxis-auto-range-slider-handle-width, 24px);
  --perxis-auto-range-slider-handle-height-inner: var(--perxis-auto-range-slider-handle-height, 24px);
  --perxis-auto-range-slider-handle-margin-top-inner: var(--perxis-auto-range-slider-handle-margin-top, -8px);
  --perxis-auto-range-slider-handle-margin-left-inner: var(--perxis-auto-range-slider-handle-margin-left, -7px);
  /* End Handle */
  /* Mark */
  --perxis-auto-range-slider-mark-margin-top-inner: var(--perxis-auto-range-slider-mark-margin-top, 21px);
  --perxis-auto-range-slider-mark-margin-left-inner: var(--perxis-auto-range-slider-mark-margin-left, 21px);
  /* End Mark */
  /* Dot */
  --perxis-auto-range-slider-dot-border-width-inner: var(--perxis-auto-range-slider-dot-border-width, 2px);
  --perxis-auto-range-slider-dot-border-radius-inner: var(--perxis-auto-range-slider-dot-border-radius, 50%);
  /* End Dot */
  /* Rail */
  --perxis-auto-range-slider-rail-height-inner: var(--perxis-auto-range-slider-rail-height, 4px);
  --perxis-auto-range-slider-rail-width-inner: var(--perxis-auto-range-slider-rail-width, 4px);
  --perxis-auto-range-slider-rail-border-radius-inner: var(--perxis-auto-range-slider-rail-border-radius, 2px);
  /* End Rail */
}
.perxis-auto-1_16_13-range-slider-wrapper--vertical {
  display: inline-flex;
  flex-direction: column;
  height: 300px;
}
.perxis-auto-1_16_13-range-slider-wrapper--input .perxis-auto-1_16_13-range-slider-header {
  margin-bottom: var(--perxis-auto-gap-vertical-blue-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_16_13-range-slider-wrapper--text .perxis-auto-1_16_13-range-slider-header {
  margin-bottom: var(--perxis-auto-gap-vertical-purple-inner);
  padding-bottom: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_16_13-range-slider-wrapper .perxis-auto-1_16_13-range-slider-header {
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  gap: 8px;
}
.perxis-auto-1_16_13-range-slider-wrapper .perxis-auto-1_16_13-range-slider-header__min, .perxis-auto-1_16_13-range-slider-wrapper .perxis-auto-1_16_13-range-slider-header__max {
  display: flex;
  flex-direction: column;
  --perxis-auto-typography-small-font-family: var(--perxis-auto-range-slider-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-range-slider-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-range-slider-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-range-slider-text-transform-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-range-slider-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-range-slider-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-range-slider-line-height-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider {
  font-family: var(--perxis-auto-range-slider-font-family-inner);
  font-size: var(--perxis-auto-range-slider-font-size-inner);
  line-height: var(--perxis-auto-range-slider-line-height-inner);
  font-weight: var(--perxis-auto-range-slider-font-weight-inner);
  text-transform: var(--perxis-auto-range-slider-text-transform-inner);
  letter-spacing: var(--perxis-auto-range-slider-letter-spacing-inner);
  color: var(--perxis-auto-range-slider-color-inner);
  margin: var(--perxis-auto-gap-vertical-purple-inner) 0 var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider.ant-5_17_0-slider-disabled .ant-5_17_0-slider-track {
  background-color: var(--perxis-auto-range-slider-track-disabled-background-color-inner) !important;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider.ant-5_17_0-slider-disabled .ant-5_17_0-slider-handle {
  border-color: var(--perxis-auto-range-slider-handle-disabled-border-color-inner) !important;
  background-color: var(--perxis-auto-range-slider-handle-disabled-background-color-inner) !important;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider.ant-5_17_0-slider-disabled .ant-5_17_0-slider-rail {
  background-color: var(--perxis-auto-range-slider-rail-disabled-background-color-inner) !important;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:hover .ant-5_17_0-slider-track {
  background-color: var(--perxis-auto-range-slider-track-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:hover .ant-5_17_0-slider-handle:not(.ant-5_17_0-tooltip-open) {
  border-color: var(--perxis-auto-range-slider-handle-border-color-inner);
  background-color: var(--perxis-auto-range-slider-handle-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:hover .ant-5_17_0-slider-rail {
  background-color: var(--perxis-auto-range-slider-rail-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-rail {
  border-radius: var(--perxis-auto-range-slider-rail-border-radius-inner);
  background-color: var(--perxis-auto-range-slider-rail-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-track {
  border-radius: var(--perxis-auto-range-slider-rail-border-radius-inner);
  background-color: var(--perxis-auto-range-slider-track-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-handle {
  box-sizing: border-box;
  border-width: var(--perxis-auto-range-slider-handle-border-width-inner);
  border-style: solid;
  border-radius: var(--perxis-auto-range-slider-handle-border-radius-inner);
  border-color: var(--perxis-auto-range-slider-handle-border-color-inner);
  background-color: var(--perxis-auto-range-slider-handle-background-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-handle:focus {
  box-shadow: none;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-handle::before, .perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-handle::after {
  content: none;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-dot {
  display: none;
  box-sizing: border-box;
  border-width: var(--perxis-auto-range-slider-dot-border-width-inner);
  border-style: solid;
  border-color: var(--perxis-auto-range-slider-dot-border-color-inner);
  border-radius: var(--perxis-auto-range-slider-dot-border-radius-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-dot-active {
  border-color: var(--perxis-auto-range-slider-dot-active-border-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-mark .ant-5_17_0-slider-mark-text {
  font-family: var(--perxis-auto-range-slider-mark-font-family-inner);
  font-size: var(--perxis-auto-range-slider-mark-font-size-inner);
  line-height: var(--perxis-auto-range-slider-mark-line-height-inner);
  font-weight: var(--perxis-auto-range-slider-mark-font-weight-inner);
  text-transform: var(--perxis-auto-range-slider-mark-text-transform-inner);
  letter-spacing: var(--perxis-auto-range-slider-mark-letter-spacing-inner);
  font-style: normal;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-mark .ant-5_17_0-slider-mark-text,
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-mark .ant-5_17_0-slider-mark-text-active {
  color: var(--perxis-auto-range-slider-mark-color-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider .ant-5_17_0-slider-handle {
  width: var(--perxis-auto-range-slider-handle-width-inner);
  height: var(--perxis-auto-range-slider-handle-height-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-handle {
  margin-top: var(--perxis-auto-range-slider-handle-margin-top-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-mark {
  margin-top: var(--perxis-auto-range-slider-mark-margin-top-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-rail {
  height: var(--perxis-auto-range-slider-rail-height-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-track {
  height: var(--perxis-auto-range-slider-rail-height-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical).ant-5_17_0-slider-with-marks {
  margin-bottom: 35px;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-handle {
  width: var(--perxis-auto-range-slider-handle-width-inner);
  height: var(--perxis-auto-range-slider-handle-height-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:not(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-mark {
  top: 0;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) {
  margin: 14px 0 10px;
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-handle {
  margin-left: var(--perxis-auto-range-slider-handle-margin-left-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-mark {
  margin-left: var(--perxis-auto-range-slider-mark-margin-left-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-rail {
  width: var(--perxis-auto-range-slider-rail-width-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-track {
  width: var(--perxis-auto-range-slider-rail-width-inner);
}
.perxis-auto-1_16_13-range-slider.ant-5_17_0-slider:is(.ant-5_17_0-slider-vertical) .ant-5_17_0-slider-mark {
  inset-inline-start: 0;
}

.ant-5_17_0-tooltip.ant-5_17_0-slider-tooltip {
  /* Typography */
  --perxis-auto-slider-tooltip-font-family-inner: var(--perxis-auto-slider-tooltip-font-family, var(--perxis-auto-root-typography-super-small-font-family-inner));
  --perxis-auto-slider-tooltip-font-size-inner: var(--perxis-auto-slider-tooltip-font-size, var(--perxis-auto-root-typography-super-small-font-size-xxl-inner));
  --perxis-auto-slider-tooltip-font-weight-inner: var(--perxis-auto-slider-tooltip-font-weight, 700);
  --perxis-auto-slider-tooltip-letter-spacing-inner: var(--perxis-auto-slider-tooltip-letter-spacing, var(--perxis-auto-root-typography-super-small-letter-spacing-inner));
  --perxis-auto-slider-tooltip-line-height-inner: var(--perxis-auto-slider-tooltip-line-height, var(--perxis-auto-root-typography-super-small-line-height-xxl-inner));
  --perxis-auto-slider-tooltip-text-transform-inner: var(--perxis-auto-slider-tooltip-text-transform, var(--perxis-auto-root-typography-super-small-text-transform-inner));
  --perxis-auto-slider-tooltip-color-inner: var(--perxis-auto-slider-tooltip-color, var(--perxis-auto-root-typography-color-darkest-inner));
  /* End Typography */
  /* Colors */
  --perxis-auto-slider-tooltip-background-color-inner: var(--perxis-auto-slider-tooltip-background-color, transition);
  /* End Colors */
  /* Z-index */
  --perxis-auto-slider-tooltip-z-index-inner: var(--perxis-auto-slider-tooltip-z-index, 1000);
  /* End Z-index */
  display: inline-block;
  font-family: var(--perxis-auto-slider-tooltip-font-family-inner);
  font-size: var(--perxis-auto-slider-tooltip-font-size-inner);
  line-height: var(--perxis-auto-slider-tooltip-line-height-inner);
  font-weight: var(--perxis-auto-slider-tooltip-font-weight-inner);
  text-transform: var(--perxis-auto-slider-tooltip-text-transform-inner);
  letter-spacing: var(--perxis-auto-slider-tooltip-letter-spacing-inner);
  color: var(--perxis-auto-slider-tooltip-color-inner);
  padding: 0;
  z-index: var(--perxis-auto-slider-tooltip-z-index-inner);
}
.ant-5_17_0-tooltip.ant-5_17_0-slider-tooltip .ant-5_17_0-tooltip-arrow {
  display: none;
}
.ant-5_17_0-tooltip.ant-5_17_0-slider-tooltip .ant-5_17_0-tooltip-inner {
  font-family: var(--perxis-auto-slider-tooltip-font-family-inner);
  font-size: var(--perxis-auto-slider-tooltip-font-size-inner);
  line-height: var(--perxis-auto-slider-tooltip-line-height-inner);
  font-weight: var(--perxis-auto-slider-tooltip-font-weight-inner);
  text-transform: var(--perxis-auto-slider-tooltip-text-transform-inner);
  letter-spacing: var(--perxis-auto-slider-tooltip-letter-spacing-inner);
  color: var(--perxis-auto-slider-tooltip-color-inner);
  min-height: auto;
  min-width: auto;
  box-shadow: none;
  border: none;
  padding: 0;
  background-color: var(--perxis-auto-slider-tooltip-background-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
